import { TceListingType } from 'domain/value-objects/tce-listing-type';

export interface TceManagementParams {
  page: number;
  length: number;
  query?: string;
  groups?: string[];
  courseHashIds?: string[];
  organizationHashIds?: string[];
  listingType: TceListingType;
  internshipLocations?: string[];
  orderDirection?: 'ASC' | 'DESC';
  signatureStatus: SIGNATURE_STATUS[];
  orderColumn?: 'STUDENT_NAME' | 'GROUP_NAME' | 'START_DATE' | 'END_DATE';
  cpf?: string;
  studentName?: string;
}

export enum SIGNATURE_STATUS {
  STUDENT = 'STUDENT',
  INSTITUTION = 'INSTITUTION',
  GRANTOR = 'GRANTOR',
}
